<template>
  <div class="animated fadeIn" id="list-assures">
    <transition name="fade">
      <b-card no-body>
        <div slot="header">
          <i class="fa fa-search mr-2"></i>
          <strong>Recherche</strong>
          <div class="card-header-actions">
            <b-link class="card-header-action btn-minimize" v-b-toggle.collapse1>
              <span class="when-opened">
                <i class="icon-arrow-down"></i>
              </span>
              <span class="when-closed">
                <i class="icon-arrow-up"></i>
              </span>
            </b-link>
          </div>
        </div>
        <b-collapse id="collapse1" hide>
          <b-card-body>
            <b-card>
              <b-form v-on:submit.prevent="search">
               	<b-row>
                <b-col sm="2">
                  <b-form-group>
                    <label for="date_envoi"><strong>Date d'envoi du:</strong></label>
                    <b-form-input type="date" id="date_envoi_debut" v-model="date_envoi_debut"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="2">
                  <b-form-group>
                    <label for="date_envoi"><strong>Date d'envoi au :</strong></label>
                    <b-form-input type="date" id="date_envoi_fin" v-model="date_envoi_fin"></b-form-input>
                  </b-form-group>
                </b-col>
	            </b-row>
                <div slot="footer">
                  <b-button type="button" @click.prevent="clearForm()" size="md" variant="secondary" class="mr-1">
                    <i class="fa fa-eraser"></i> Effacer
                  </b-button>
                  <b-button type="enter" @click.prevent="search()" size="md" variant="primary">
                    <i class="fa fa-search"></i> Rechercher
                  </b-button>
                </div>
              </b-form>
            </b-card>
          </b-card-body>
        </b-collapse>
      </b-card>
    </transition>
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i>
        <strong>Liste des fichiers intégrés</strong>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col sm="5">
            <b-button v-if="canGenerateCsv()"
              type="button" variant="success"
              @click.stop.prevent="generateCsv()"
              class=""
            >
              <i class="fa fa-gog"></i> Réaliser le rammassage et générer le fichier XML
            </b-button>
          </b-col>
          <b-col sm="7">
            <b-form inline>
              <b-form-file placeholder="Joindre un ou plusieurs fichiers"
                           class="file-input col-7 d-inline-block"
                           drop-placeholder="Déposer le/les fichiers ici..."
                           browse-text="Parcourir"
                           :state="errors.xmlFile !== '' ? false : null"
                           @change="addFile($event)"
                           multiple>
              </b-form-file>
              <b-button v-if="canGenerateCsv()"
                  type="button" variant="warning"
                  @click.stop.prevent="sendXml()"
                  class=""
                >
                <i class="fa fa-gog"></i> envoyer le fichier XML
              </b-button>
            </b-form>
            <span class="field-error">{{ errors.xmlFile }}</span>
          </b-col>
        </b-row>
        <v-client-table v-if="dataIsReady" class="mt-4" :columns="columns" :data="items" :options="options" @row-click="downloadCsv">
          <div slot="date_envoi" slot-scope="props" class="slot-date">
            <span class="badge badge-success p-2">{{ formatDate(props.row.created_at) }}</span>
          </div>
  	      <div slot="nom_fichier" slot-scope="props" >
  	        {{ props.row.nom_fichier }}
  	      </div>
          <div v-if="props.row.status" slot="status" slot-scope="props">
              <span v-if="props.row.status.libelle_technique === 'en_cours_integration'" class="badge badge-warning p-2">{{ props.row.status.libelle_bo }}</span>
              <span v-else-if="props.row.status.libelle_technique === 'traite_integre'" class="badge badge-success p-2">{{ props.row.status.libelle_bo }}</span>
              <span v-else class="badge badge-danger p-2">{{ props.row.status.libelle_bo }}</span>
          </div>
         <div slot="action" slot-scope="props">
          <b-button
            type="button"
            @click.stop.prevent="downloadCsv(props.row)"
            class="btn btn-success ml-2"
            :disabled="!canSeeFiles(props.row)"
          >
            <i class="fa fa-file-excel-o"></i> csv
          </b-button>
          <b-button
            type="button"
            @click.stop.prevent="downloadXml(props.row)"
            class="btn btn-success ml-2"
            v-if="props.row.nom_fichier.indexOf('xml') > -1"
            :disabled="!canSeeFiles(props.row)"
          >
            <i class="fa fa-file-code-o"></i> xml
          </b-button>

          <b-button v-if="props.row.nom_fichier_log"
            type="button" variant="primary"
            @click.stop.prevent="downloadLog(props.row,'log')"
            class="btn btn-primary ml-2"
            :disabled="!canSeeFiles(props.row)"
          >
            <i class="fa fa-file-text-o"></i> log
          </b-button>

          <b-button v-if="props.row.nom_fichier_bad"
            type="button"  
            @click.stop.prevent="downloadLog(props.row,'bad')"
            class="btn btn-danger ml-2"
            :disabled="!canSeeFiles(props.row)"
          >
            <i class="fa fa-file-excel-o"></i> bad
          </b-button>

          </div>
        </v-client-table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider, getUser} from "@/utils/auth";
  import {rules, hasRule} from "@/utils/rulesHelper";
  import {downloadFile, isEmpty} from "@/utils/fileHelper";
  import moment from 'moment';

  export default {
    data() {
      return {
        date_envoi_debut: '',
        date_envoi_fin: '',
        dataIsReady : false,
        items: [],
        columns: ['date_envoi', 'nom_fichier','status','action'],
        options: {
          headings: {
            date_envoi: 'Date envoi',
            nom_fichier: 'Nom Fichier',
            status: 'Statut',
            action: 'Action',
          },
          perPage: 10,
          filterable: false,
          sortable: ['date_envoi','nom_fichier','status'],
          perPageValues: [10, 25, 50],
        },
        errors: {
          xmlFile: ''
        },
        xmlFile: null,
      };
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.all();
    },
    computed: {

    },
    methods: {
      search() {
      	return true;
      },
      all() {
        this.$store.commit("IS_LOADING", true);
        this.$axios
          .get("/espaceGestion/module_prev/getHistoriqueIntegrationNsi")
          .then(response => {
            this.$store.commit("IS_LOADING", false);
            this.items = response.data.data;
            this.dataIsReady = true;
          })
          .catch(function(error) {
            self.$store.commit("IS_LOADING", false);
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
      search() {
        let self = this;
        let dataPost = {}
        dataPost.date_envoi_debut = this.date_envoi_debut
        dataPost.date_envoi_fin = this.date_envoi_fin

        this.$store.commit("IS_LOADING", true);
        this.$axios
          .post("/espaceGestion/module_prev/search", dataPost)
          .then(response => {
            this.$store.commit("IS_LOADING", false);
            this.items = response.data.data
            this.dataIsReady = true;
          })
          .catch(function(error) {
            self.$store.commit("IS_LOADING", false);
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
      formatDate(textDate) {
        return textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      },
      clearForm() {
        this.date_envoi_debut = '',
        this.date_envoi_fin = ''
      },
      addFile(event) {
        this.xmlFile = event.target.files;
      },
      sendXml() {
        if (this.validateForm()) {
          // let periodes = {};
          // periodes = this.preparePeriode()
          let formData = new FormData();
          for( var i = 0; i < this.xmlFile.length; i++ ){
              let file = this.xmlFile[i];
              formData.append('files[' + i + ']', file);
          }
          this.$store.commit('IS_LOADING', true)
          this.$axios
            .post('/espaceGestion/module-prev/upload-xml',
              formData, {headers: {'Content-Type': 'multipart/form-data'}})
            .then(() => {
              this.$store.commit('IS_LOADING', false)
              this.$swal({
                position: 'top',
                type: 'success',
                title: 'Création avec succès',
                text: 'Une nouvelle pièce jointe a bien été créée',
                showConfirmButton: false,
                timer: 4000
              });
            })
            .catch(() => {
              this.$store.commit('IS_LOADING', false)
              this.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: 'Une erreur est survenue lors de l\'envoi du fichier. Si le problème persiste, merci de faire un ticket au support DOSI.',
                showConfirmButton: false,
                timer: 5000
              });
            })
            .finally(() => this.$store.commit('IS_LOADING', false));
        }
      },
      validateForm() {
        let isValid = true;
        if (this.xmlFile === null) {
          isValid = false;
          this.errors.xmlFile = 'Vous devez choisir un fichier.';
        } else {
          let nameAr = this.xmlFile[0].name.split('.');
          let ext = nameAr[nameAr.length -1];
          if (ext.toLowerCase() !== 'xml') {
            isValid = false;
            this.errors.xmlFile = 'Extension non autorisée, vous devez choisir un fichier XML.';
          }
        }

        return isValid;
      },
      downloadCsv(row) {
        let self = this;
        let name = row.nom_fichier.split('.')[0];
        let ext = 'csv';
        this.$store.commit('IS_LOADING', true);
        this.$axios.get('/espaceGestion/module_prev/downloadFichierIntegration/'+ row.id, {responseType: 'blob'})
          .then(response => {
            this.$store.commit('IS_LOADING', false);
            downloadFile(response, name, ext);
          })
          .catch(function (error) {
            self.$store.commit('IS_LOADING', false);
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue pendant la récupération du fichier, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
      downloadXml(row) {
        let self = this;
        let name = row.nom_fichier.split('.')[0];
        let ext = 'xml';
        this.$store.commit('IS_LOADING', true);
        this.$axios.get('/espaceGestion/module_prev/downloadFichierIntegrationXml/'+ row.id, {responseType: 'blob'})
          .then(response => {
            this.$store.commit('IS_LOADING', false);

            downloadFile(response, name, ext);
          })
          .catch(function (error) {
            self.$store.commit('IS_LOADING', false);
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue pendant la récupération du fichier, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
      downloadLog(row,type) {
        let self = this;
        let name = type === 'log' ? row.nom_fichier_log : row.nom_fichier_bad;
        let downloadName = name.split('.')[0];
        let pj = row.pieces_jointes.find(pj => pj.extension === type)

        let ext = type;
        this.$store.commit('IS_LOADING', true);
        this.$axios.get('/espaceGestion/module_prev/downloadFichierIntegrationLog/'+ pj.id, {responseType: 'blob'})
          .then(response => {
            this.$store.commit('IS_LOADING', false);
            downloadFile(response, downloadName, ext);
          })
          .catch(function (error) {
            self.$store.commit('IS_LOADING', false);
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue pendant la récupération du fichier, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
      canGenerateCsv() {
        // Comme la fonction est temporaire et seulement accessible au super admin, on prend un droit propre au super admin
        return hasRule(rules.MANAGE_ADMIN_BAL);
      },
      generateCsv() {
        let self = this;
        // let downloadName = 'D-DECLAIJ-CHORUM-92063-'+moment().format('YYYYMMDD');
        // let ext = 'xml';
        this.$store.commit('IS_LOADING', true);
        // this.$axios.get('/espaceGestion/module_prev/generateCsv', {responseType: 'blob'})
        this.$axios.get('/espaceGestion/module_prev/generateCsv')
          .then(response => {
            this.$store.commit('IS_LOADING', false);
            // if (response && response.request && !isEmpty(response.request.getResponseHeader('fileName'))) {
            //   let fullName = response.request.getResponseHeader('fileName');
            //   downloadName = fullName.substring(0, fullName.length -4);
            // }
            // downloadFile(response, downloadName, ext);
            this.all();
          })
          .catch(function (error) {
            console.log(error)
            self.$store.commit('IS_LOADING', false);
            let textError = 'Une erreur est survenue pendant la récupération du fichier, si le problème persiste merci de faire un ticket au support DOSI';

            if (error && error.response && error.response.status === 424) {
              textError = error.response.data.message;
            }
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: textError,
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
      canSeeFiles(row) {
        let user = getUser();
        let userOags = user.profil_active[0].oags.map(oag => oag.code);
        if (row.type === 'confidentiel' && userOags.indexOf('92080') === -1) {
          return false;
        }

        return true;
      },
    }
  };
</script>

